import React, { Component } from 'react';
import classes from './Survey.module.scss';

import Navigation from '../../components/Navigation/Navigation';
import Question from '../../components/Question/Question';
import Answers from "../../components/Answers/Answers";
import Response from "../../components/Response/Response";
import Button from '../../components/Button/Button';
import Aux from '../../hoc/Aux';
import * as actionTypes from "../../store/actions";
import {connect} from "react-redux";

class Survey extends Component {

    QuestionsData = require( '../../data/' + this.props.mode + '-questions.js' );

    componentDidMount() {
        this.resetScrollPosition();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.resetScrollPosition();
    }

    resetScrollPosition() {
        const currentScrollPosition = window.pageYOffset;

        const headingElement = document.getElementById( 'bf-instant-quote-heading' );

        if( headingElement ) {
            if( currentScrollPosition > headingElement.offsetTop ) {
                window.scrollTo( {
                    top: headingElement.offsetTop,
                    behavior: 'smooth'
                } );
            }
        }
    }

    render() {

        const theQuestion = this.QuestionsData[ this.props.version ][ this.props.current_question_index ];

        const selectedAnswer = this.props.question_answers[ this.props.current_question_index ];

        return (
            <div className={classes.Survey}>
                <div className={classes.Progress}>
                    <Navigation totalItems={this.QuestionsData[ this.props.version ].length}
                                currentItem={this.props.current_question_index}
                                version={this.props.version}
                                onItemClick={this.props.goToQuestion}
                    />
                </div>

                <div className={[classes.QuestionContainer,classes['LightBG-'+this.QuestionsData[ this.props.version ][ this.props.current_question_index ].color_scheme]].join(' ')}>

                    { ( this.props.show_response ) ? (
                        <Response response={this.props.response_text}
                                  currentItem={this.props.current_question_index}
                                  version={this.props.version}
                                  onButtonClick={this.props.showNextQuestion}
                        />
                    ) : (
                        <Aux>
                            <Question>{theQuestion.question}</Question>

                            <Answers answerList={theQuestion.answers}
                                     questionIndex={this.props.current_question_index}
                                     onChooseAnswer={this.props.onChooseAnswer}
                                     selectedAnswer={selectedAnswer}
                                     version={this.props.version}
                            />
                        </Aux>
                    ) }

                    { ( this.props.current_question_index > 0 || this.props.show_response ) ? (
                        <Button onButtonClick={this.props.goBack}
                                addClass={classes['FG-' + this.QuestionsData[ this.props.version ][this.props.current_question_index].color_scheme]}
                                textLink={true}>BACK</Button>
                    ) : null }
                </div>
            </div>
        );

    }

}

const mapStateToProps = state => {
    return {
        current_question_index: state.current_question_index,
        question_answers: state.question_answers,
        show_response: state.show_response,
        response_text: state.response_text,
        version: state.version,
        mode: state.mode,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onChooseAnswer: ( answerIndex ) => dispatch( { type: actionTypes.CHOOSE_ANSWER, answerIndex: answerIndex } ),
        showNextQuestion: () => dispatch( { type: actionTypes.NEXT_QUESTION } ),
        goBack: () => dispatch( { type: actionTypes.GO_BACK } ),
        goToQuestion: ( questionIndex ) => dispatch( { type: actionTypes.GO_TO_QUESTION, questionIndex: questionIndex } ),
    }
};

export default connect( mapStateToProps, mapDispatchToProps )( Survey );
